import api from './api';

const authService = {
  // Iniciar sesión
  login: async (credentials) => {
    return await api.post('/auth/login', credentials);
  },

  // Obtener información del usuario actual
  getCurrentUser: async () => {
    return await api.get('/auth/me');
  },

  // Cerrar sesión
  logout: async () => {
    return await api.post('/auth/logout');
  },

  // Solicitar recuperación de contraseña
  forgotPassword: async (email) => {
    return await api.post('/auth/recuperar-password', { email });
  },

  // Restablecer contraseña con token
  resetPassword: async (token, password) => {
    return await api.post('/auth/restablecer-password', { token, password });
  },
};

export default authService;